export const excludedKeys = ["bot name", "commands usage count"];
export const keysToModify = [
    "current number of users",
    "number of commands",
    "total commands used",
    "total data updates",
];
export const modifiedKeys = [
    {
        originalKey: "current number of users",
        newKey: "users",
    },
    {
        originalKey: "number of commands",
        newKey: "commands",
    },
    {
        originalKey: "total commands used",
        newKey: "commands used",
    },
    {
        originalKey: "total data updates",
        newKey: "data updates",
    },
];